import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.app.breadcrumbs;

const getBreadcrumbs = createSelector(getData, crumbs => crumbs);

export default getBreadcrumbs;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/getBreadcrumbs.js